import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { closeTableModal } from '@/services/table/tableActions';
import { TableModalTypes, TableState } from '@/services/table/tableState';
import DuplicateTableModal from '@/pages/table/components/DuplicateTableModal/DuplicateTableModal';
import TableInfoModal from '@/pages/table/components/TableInfoModal/TableInfoModal';
import LeaveTableModal from '@/pages/table/components/LeaveTableModal/LeaveTableModal';

const TableModal = () => {
  const { tableId } = useParams();
  const dispatch = useDispatch();

  const { table }: { table: TableState } = useSelector((state: any) => ({
    table: state.tables[tableId as string],
  }));

  const handleCloseModal = () => {
    dispatch(closeTableModal(tableId));
  };

  if (!table?.modal) {
    return null;
  }

  const TableModals: Record<TableModalTypes, JSX.Element> = {
    [TableModalTypes.DUPLICATE_TABLE_CONNECTION]: <DuplicateTableModal onClose={handleCloseModal} table={table} />,
    [TableModalTypes.TABLE_INFO]: (
      <TableInfoModal
        open
        setClose={handleCloseModal}
        maxPlayers={table.maxPlayers}
        currentPlayers={table.seats?.filter((seat) => seat !== null).length}
        name={table.name}
        gameParams={table.gameParams}
        currentVariant={table.currentVariant}
        variants={table.variants}
      />
    ),
    [TableModalTypes.LEAVE_TABLE]: <LeaveTableModal isOpen onClose={handleCloseModal} tableId={table.tableId} />,
  };

  const DerivedComponent = TableModals[table.modal.type];

  if (!DerivedComponent) {
    return null;
  }

  return DerivedComponent;
};

export default TableModal;
